export const SET_PARTNER_TYPES = "setPartnerTypes";
export const SET_USER = "setUser";
export const MANAGE_LOADING_BASE_DATA = "manageLoadingBaseData";
export const MANAGE_EDITING_USER = "manageEditingUser";